require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-best-australian-interiors-architecture-design-yellow-trace.json") })
        }
      }, "path---journal-best-australian-interiors-architecture-design-yellow-trace");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-best-australian-interiors-architecture-design-yellow-trace!./.cache/json/journal-best-australian-interiors-architecture-design-yellow-trace.json
// module id = 460
// module chunks = 231608221292675